import { ChangeEvent } from "react";
import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputLabel,
  Radio,
  RadioGroup,
  RadioGroupProps
} from "@material-ui/core";

type Option = {
  label: React.ReactNode;
  value: string | number;
};

export type RadioButtonGroupProps = {
  name?: string;
  value: string | number;
  onChange: (event: ChangeEvent<HTMLInputElement>, value: string) => void;
  options: Option[];
  label?: string;
  helperText?: string;
  required?: boolean;
  error?: boolean;
  disabled?: boolean;
  RadioGroupProps?: Partial<RadioGroupProps>;
};

export function RadioButtonGroup(props: RadioButtonGroupProps) {
  return (
    <FormControl
      disabled={props.disabled}
      error={props.error}
      required={props.required}
      variant="outlined"
    >
      {props.label && (
        <InputLabel
          htmlFor={props.name}
          required={props.required}
          error={props.error}
          shrink={true}
        >
          {props.label}
        </InputLabel>
      )}

      <RadioGroup
        name={props.name}
        value={props.value || ""}
        onChange={props.onChange}
        {...props.RadioGroupProps}
      >
        {props.options.map((option) => (
          <FormControlLabel
            key={option.value}
            value={option.value}
            control={<Radio size="small" />}
            label={option.label}
            style={{ paddingTop: "8px" }}
          />
        ))}
      </RadioGroup>

      {props.helperText && (
        <FormHelperText error={props.error}>{props.helperText}</FormHelperText>
      )}
    </FormControl>
  );
}
